import getConstraints from './constraints';

export default {
  getConstraints,
};
